import(/* webpackMode: "eager" */ "/app/apps/eurodrive/app/global-error.tsx");
